export const NewsSecond = ({ width = 20, height = 20, color = 'white' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.875 1H2.125C0.953 1 0 1.897 0 3V17C0 18.103 0.953 19 2.125 19H17.875C19.047 19 20 18.103 20 17V3C20 1.897 19.047 1 17.875 1ZM17.875 17H2.125C2.068 17 2.029 16.984 2.012 16.984C2.005 16.984 2.001 16.986 2 16.992L1.988 3.046C1.995 3.036 2.04 3 2.125 3H17.875C17.954 3.001 17.997 3.028 18 3.008L18.012 16.954C18.005 16.964 17.96 17 17.875 17Z"
        fill={color}
      />
      <path
        d="M4 5H10V11H4V5ZM11 13H4V15H16V13H12H11ZM12 9H16V11H12V9ZM12 5H16V7H12V5Z"
        fill={color}
      />
    </svg>
  );
};
